import { cn } from 'src/components/ui/utils';
import { LedgerAccountType } from 'types/graphql';

export const accountToLabelMap: Record<LedgerAccountType, 'Asset' | 'Liability' | 'Income' | 'Expense'> = {
  CashAssets: 'Asset',
  CurrentAssets: 'Asset',
  LongTermAssets: 'Asset',
  OtherAssets: 'Asset',
  CurrentLiabilities: 'Liability',
  LongTermLiabilities: 'Liability',
  Equity: 'Liability',
  Income: 'Income',
  OtherIncome: 'Income',
  DirectCosts: 'Expense',
  IndirectCosts: 'Expense',
  OtherCosts: 'Expense',
  asset: 'Asset',
  expense: 'Expense',
  income: 'Income',
  liability: 'Liability',
};

const typeColorClasses = {
  Asset: 'bg-blue-bg text-blue-text border border-blue-border',
  Liability: 'bg-orange-bg text-orange-text border border-orange-border',
  Income: 'bg-green-bg text-green-text border border-green-border',
  Expense: 'bg-red-bg text-red-text border border-red-border',
};

export default function LedgerAccountTypeChip({ type, label }: { type: LedgerAccountType; label?: string }) {
  const accountType = accountToLabelMap?.[type];

  if (!accountType) {
    return null;
  }

  return (
    <span className={cn('px-2 py-1 rounded-full text-12 font-medium', typeColorClasses[accountType])}>
      {label || accountType}
    </span>
  );
}
